export const INTEGRATIONS_WELCOME_PENDING_USER_ID_KEY =
  "integrations_welcome_pending_user_id";
